// @mui material components
import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";
import { cc } from "afms/theme/commandCenterTheme";

export default styled(Drawer)(({ theme, ownerState }) => {
  const { palette, boxShadows, transitions, breakpoints, functions } = theme;
  const { transparentSidenav, miniSidenav, isAfms } = ownerState;

  const sidebarWidth = isAfms ? 280 : 250;
  const { white, transparent } = palette;
  const { xxl } = boxShadows;
  const { pxToRem } = functions;

  // styles for the sidenav when miniSidenav={false}
  const drawerOpenStyles = () => ({
    transform: "translateX(0)",
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("xl")]: {
      backgroundColor: isAfms ? cc.navy : transparentSidenav ? transparent.main : white.main,
      backgroundImage: isAfms ? `linear-gradient(180deg, ${cc.navy} 0%, ${cc.navy2} 100%)` : "none",
      boxShadow: isAfms || transparentSidenav ? "none" : xxl,
      marginBottom: transparentSidenav ? 0 : "inherit",
      left: "0",
      width: sidebarWidth,
      transform: "translateX(0)",
      transition: transitions.create(["width", "background-color"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.enteringScreen,
      }),
    },
  });

  // styles for the sidenav when miniSidenav={true}
  const drawerCloseStyles = () => ({
    transform: `translateX(${pxToRem(-320)})`,
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("xl")]: {
      backgroundColor: isAfms ? cc.navy : transparentSidenav ? transparent.main : white.main,
      backgroundImage: isAfms ? `linear-gradient(180deg, ${cc.navy} 0%, ${cc.navy2} 100%)` : "none",
      boxShadow: isAfms || transparentSidenav ? "none" : xxl,
      marginBottom: transparentSidenav ? 0 : "inherit",
      left: "0",
      width: pxToRem(isAfms ? 96 : 96),
      overflowX: "hidden",
      transform: "translateX(0)",
      transition: transitions.create(["width", "background-color"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.shorter,
      }),
    },
  });

  return {
    "& .MuiDrawer-paper": {
      boxShadow: isAfms ? "none" : xxl,
      border: "none",
      ...(isAfms && {
        width: miniSidenav ? pxToRem(96) : pxToRem(sidebarWidth),
        height: "100vh",
        color: "#fff",
        backgroundColor: cc.navy,
        backgroundImage: `linear-gradient(180deg, ${cc.navy} 0%, ${cc.navy2} 100%)`,
        borderRight: "1px solid rgba(255,255,255,0.08)",
      }),

      ...(miniSidenav ? drawerCloseStyles() : drawerOpenStyles()),
    },
  };
});
